import { useContext } from 'react';
import { GeneralContext } from '@frodo/lib/providers/GeneralProvider';

export const useStore = () => {
  const context = useContext(GeneralContext);

  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }

  return context.store;
};
